/* tslint:disable */
/* eslint-disable */
/**
 * merged spec
 * merged spec
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ActivityState;
(function (ActivityState) {
    ActivityState["Canceled"] = "canceled";
    ActivityState["ForfeitAway"] = "forfeit_away";
    ActivityState["ForfeitBoth"] = "forfeit_both";
    ActivityState["ForfeitHome"] = "forfeit_home";
    ActivityState["PlayedRegularTime"] = "played_regular_time";
    ActivityState["PlayedOvertime"] = "played_overtime";
    ActivityState["Rescheduled"] = "rescheduled";
    ActivityState["Scheduled"] = "scheduled";
    ActivityState["Unscheduled"] = "unscheduled";
})(ActivityState || (ActivityState = {}));
